import { render, staticRenderFns } from "./picPage.vue?vue&type=template&id=b779b3ea&"
import script from "./picPage.vue?vue&type=script&lang=ts&"
export * from "./picPage.vue?vue&type=script&lang=ts&"
import style0 from "./picPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports